import { openSettingModal } from '../State/settingModal'

export default () => (dispatch) => {

  dispatch(openSettingModal())
  
}
